import { useCallback, useEffect, useState } from 'react'
import {
  useFilters,
  useGetAddressesFilter
} from '@/modules/accredited-establishments/hooks'
import { debounce } from 'lodash'
import { FilterItem } from '@/modules/accredited-establishments/api/types'
import { CHANGE_ADDRESS_DEBOUNCE_TIME } from '@/modules/accredited-establishments/constants'

const useAddressSearch = () => {
  const { address, updateAddress } = useFilters()

  const [addressSearchLabel, setAddressSearchLabel] = useState<string>('')
  const [addressValue, setAddressValue] = useState<FilterItem>()

  const { data: addresses, isLoading } = useGetAddressesFilter({
    addressSearchLabel
  })

  useEffect(() => {
    if (address && !addressSearchLabel) {
      setAddressSearchLabel(address.title)
    }
  }, [address])

  useEffect(() => {
    setAddressValue(address)
  }, [address])

  const onChangeAddress = (search: string) => {
    setAddressSearchLabel(search)
  }

  const debouncedOnChangeAddress = useCallback(
    debounce(onChangeAddress, CHANGE_ADDRESS_DEBOUNCE_TIME),
    []
  )

  return {
    address: addressValue,
    addresses,
    addressSearchLabel,
    isLoading,
    updateAddress,
    setAddressSearchLabel,
    onChange: debouncedOnChangeAddress
  }
}

export { useAddressSearch }
